<template>
<div class="container">
	<div class="title has-text-centered">
		My Mentors
	</div>

	<FormErrors v-bind:errors="mentorships.errors.detail" />

	<div class="columns is-centered">
		<div class="column is-8" style="max-height: min(600px, 60vh); overflow-y: auto;">
			<ul v-if="mentorships.data.length === 0">
				<li class="box has-text-centered is-centered has-text-weight-bold has-background-white">
					No mentors
				</li>
			</ul>
			<ul v-else>
				<li>
					<div class="columns is-vcentered">
						<div class="column">
							<p style="font-weight: 700; font-size: larger;">Name</p>
						</div>
						<div class="column">
							<p style="font-weight: 700; font-size: larger;">Project Title</p>
						</div>
						<div class="column">
							<p style="font-weight: 700; font-size: larger;">Action</p>
						</div>
					</div>
				</li>
				<li v-for="mentorship in mentorships.data" class="box is-rounded mb-4">
					<div class="columns is-vcentered">
						<div class="column">
							<router-link v-bind:to="{ name: 'MentorProfilePage', params: { profile_uid: mentorship.mentor } }"
										 class="hyperlink">
								{{ mentorship.mentor_name }}
							</router-link>
						</div>
						<div class="column">
							{{ mentorship.project_title }}
						</div>
						<div class="column is-narrow">
							{{ get_mentorship_status(mentorship.status) }}
						</div>
						<div class="column is-narrow">
							<!-- TODO Change the following to router-link to the specific mentor-mentee page -->
							<router-link v-if="mentorship.status == 1" v-bind:to="{ name: 'MentorshipPage', params: { mentorship_uid: mentorship.uid } }"
							class="button is-info">Mentorship Page</router-link>
							<button v-else
								class="button is-info mr-2"
								title="On going"
								disabled
							>Mentorship Page </button>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import axios from "../../api/my-axios";
import FormErrors from "../../components/FormHelpers/FormErrors";

export default {
	components: {
		FormErrors
	},
	computed: {
		...mapState({
			user: "user"
		})
	},
	data() {
		return {
			mentorships: {
				request_token: {
					// mentee: ""
				},

				errors: {},

				data: [
					// {
					// 	uid: "",
					// 	mentor: "",
					// 	mentee: "",
					// }
				]
			},
		};
	},
	created() {
		this.mentorships.request_token.mentee = this.user.profile_uid;
		this.get_mentorships();
	},
	methods: {
		get_mentorships()
		{
			axios
				.get("/api/mentorship/mentorship/", {
					params: {
						...this.mentorships.request_token
					}
				})
				.then(response => {
					this.mentorships.data = response.data;
				})
				.catch(error => {
					this.mentorships.errors = error.response ? error.response.data : {"detail": [error.message]};
				});
		},

		get_mentorship_status(status){
			if (status == 1) return "On going";
			else if (status == 2) return "Completed";
			else if (status == 3) return "Rejected";
		}
	}
}
</script>
